import {
  SUBSCRIBE_POSITION_UPDATES,
  UNSUBSCRIBE_POSITION_UPDATES,
} from '../constants/ActionTypes';

const processLiveFeed = (data) => {
  if (data.state && data.state.positions && data.state.positions.length) {
    data.state.positions = data.state.positions.filter((a) => a) || [];
  }

  return data;
};

export default function liveFeed(
  state = { data: {}, isFetching: false, errorMessage: null },
  action
) {
  switch (action.type) {
    case SUBSCRIBE_POSITION_UPDATES:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: processLiveFeed(action.data),
      };
    case UNSUBSCRIBE_POSITION_UPDATES:
      return {
        ...state,
        isFetching: false,
        errorMessage: null,
        data: {},
      };
    default:
      return state;
  }
}
